import React from "react";
import { Link, Outlet } from "react-router-dom";
import "./About.css";

const About = () => {
  return (
    <div style={{ height: "88vh" }}>
      <section className="hero-img">
      </section>
      <section className="container mt-4 text-center">
        <h6 className="text-warning">Luxury Resort</h6>
        <h2>We're gonna make this place your home</h2>
        <p>
          Royalish Resort is the combination of innovative design and crafted
          luxury and set apart by an unprecedented level of personalised
          hospitality, private spaces and bespoke journeys. Here, We Combine
          comfort, personalized service and exceptional values.
        </p>
      </section>
      <section className="container mt-4">
        <div className="brick-and-morter text-center d-flex gap-5 justify-content-center">

        </div>
        <div>
          <Outlet></Outlet>
        </div>
      </section>
    </div>
  );
};

export default About;
